import React, { Fragment, useState, useEffect } from 'react';
import PercentageGraph from './components/PercentageGraph';
import './style.scss';
import BlueCircleButton from './components/BlueCircleButton';
import PerformanceTierPopover from './components/PerformanceTierPopover';
import cn from 'classnames';
import { useTable } from 'chameleon/ui-stack/ui/base/table';
import Tooltip from 'chameleon/ui-stack/ui/base/tooltip';
import { LoadingSpinner } from 'legacy-packages/ft-cb';
import QuestionsAvgPerformancePopover from './components/QuestionsAvgPerformancePopover';
import { connect } from 'react-redux';
import { getStudentData } from '../client';
import { round } from 'chameleon/src/utility/utils';
import { keyNames } from 'chameleon/legacy/src/utility/accessibility';
import { setMathJaxTypeset } from 'chameleon-src/utility/utils';
import useDynamicColspan from '../hooks/useDynamicColspan';
import PercentageBox from '../Table/components/PercentageBox';
import AssessmentsModal from './components/AssessmentsModal';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import AssessmentAssignedInfoPopover from '../Popovers/AssessmentAssignedInfoPopover';

export const showRow = (percentage, checkedItems) => {
  let showRow = false;
  if (checkedItems.notAssessed && Number.isNaN(percentage)) {
    showRow = true;
  }
  if (checkedItems.firstQuartile && percentage >= 0 && percentage <= 24.9999) {
    showRow = true;
  }
  if (
    checkedItems.secondQuartile &&
    percentage >= 25 &&
    percentage <= 49.9999
  ) {
    showRow = true;
  }
  if (checkedItems.thirdQuartile && percentage >= 50 && percentage <= 74.9999) {
    showRow = true;
  }
  if (checkedItems.fourthQuartile && percentage >= 75 && percentage <= 100) {
    showRow = true;
  }
  return showRow;
};

const TrendReportTable = ({
  assignmentsIds,
  checkedItems,
  tags,
  assessments,
  firstDateScored,
  lastDateScored,
  loading,
  selectedCategoryLabel,
  courseOutline,
  isStudent,
  paramsData,
  hideAcessments = false,
  openVideo,
  subjectId,
  educationPeriod,
  setSortedLabels,
}) => {
  const [tierModalIdxOpen, setTierModalIdxOpen] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [popoverIsOpen, setPopoverIsOpen] = useState(false);
  const [studentResultData, setStudentResultData] = useState({});
  const [assessmentsPopOverData, setAssessmentsPopOverData] = useState({
    labelDescription: '',
    assessmentsScoreData: [],
  });
  const [isAssessmentsPopOverOpen, setIsAssessmentsPopOverOpen] =
    useState(false);

  const dynamicColspan = useDynamicColspan();

  const { subunitLabel } = courseOutline || {};

  const isRenderingUnit = selectedCategoryLabel === 'Unit';
  const isRenderingSubunit = !!subunitLabel?.includes(selectedCategoryLabel);

  const toggleTable = () => {
    setIsExpanded((prevState) => !prevState);
    closePopovers();
  };

  const formatDate = (date) => {
    const dateToFormat = new Date(date);
    const options = { month: '2-digit', day: '2-digit' };
    const formattedDate = dateToFormat.toLocaleString('en-US', options);
    return formattedDate; // Output: "January 13"
  };

  const handleNumStudentsClick = (index, tagId, questionIds) => {
    setTierModalIdxOpen(index);
    getStudentData({
      ...paramsData,
      tagId,
      questionIds,
    }).then((responseData) => {
      const noResults = responseData.filter(
        (responseItem) => responseItem.answers.length === 0,
      );
      const studentResults = responseData.filter(
        (responseItem) => responseItem.answers.length !== 0,
      );
      const firstQuartile = [];
      const secondQuartile = [];
      const thirdQuartile = [];
      const fourthQuartile = [];

      studentResults.map((studentResult) => {
        let cumulativePoints = 0;
        const numAnswers = studentResult.answers.length;
        studentResult.answers.map((answer) => {
          const questionResult = answer.pointsEarned / answer.maxPoints;
          cumulativePoints += questionResult;
        });
        const studentScore = round((cumulativePoints / numAnswers) * 100);
        if (studentScore >= 0 && studentScore < 25) {
          firstQuartile.push({
            firstName: studentResult.firstName,
            lastName: studentResult.lastName,
            score: studentScore,
          });
        }
        if (studentScore >= 25 && studentScore < 50) {
          secondQuartile.push({
            firstName: studentResult.firstName,
            lastName: studentResult.lastName,
            score: studentScore,
          });
        }
        if (studentScore >= 50 && studentScore < 75) {
          thirdQuartile.push({
            firstName: studentResult.firstName,
            lastName: studentResult.lastName,
            score: studentScore,
          });
        }
        if (studentScore >= 75 && studentScore <= 100) {
          fourthQuartile.push({
            firstName: studentResult.firstName,
            lastName: studentResult.lastName,
            score: studentScore,
          });
        }
      });
      setStudentResultData({
        noResults,
        firstQuartile,
        secondQuartile,
        thirdQuartile,
        fourthQuartile,
      });
    });
  };

  const headerAVGPerformanceCollapsed = {
    Header: (
      <div className="avg-span">
        {dynamicColspan === 2 ? 'Average Perf %' : 'Average Performance %'}
      </div>
    ),
    accessor: 'percentage',
    className: 'header',
  };

  const headerAVGPerformanceExpanded = {
    Header: (
      <div className="avg-span">
        {dynamicColspan === 2 ? 'Average Perf %' : '%'}
      </div>
    ),
    accessor: 'percentage',
    className: 'trend_report_border_separator header',
  };

  const minusSignIconHeader = {
    Header: (
      <div className="trend_report_toggle_table_button">
        <BlueCircleButton onClicked={toggleTable} />
      </div>
    ),
    id: 'sub_col_13a',
    className:
      'trend_report_border_separator trend_report_border_separator--icon header',
  };

  const plusSignIconHeader = {
    Header: (
      <div className="trend_report_toggle_table_button">
        <BlueCircleButton onClicked={toggleTable} plusSign />
      </div>
    ),
    id: 'sub_col_13a',
    className:
      'trend_report_border_separator trend_report_border_separator--icon header',
  };

  const noIconHeader = {
    Header: (
      <div className="trend_report_toggle_table_button">
        <div
          style={{
            width: '45px',
            height: '45px',
          }}
        />
      </div>
    ),
    id: 'sub_col_13a',
    className:
      'trend_report_border_separator trend_report_border_separator--icon border_radius_right header',
  };

  const assignmentPerformanceColumns = () => {
    const columns = assessments.map(({ title, id }) => ({
      Header: (
        <AssessmentAssignedInfoPopover
          assessmentId={id}
          subjectId={subjectId}
          title={title}
          educationPeriod={educationPeriod}
          isStudent={isStudent}
          assignmentsIds={assignmentsIds}
        />
      ),
      accessor: `assessment_${id}`,
      className: 'header_right',
    }));
    return columns;
  };

  const getHeaders = () =>
    assessments.length > 4
      ? headerAVGPerformanceExpanded
      : headerAVGPerformanceCollapsed;

  let headers = [
    {
      Header: 'CUMULATIVE PERFORMANCE',
      className: cn(
        'text-gray-700',
        'font-normal',
        'text-base',
        'tracking-wide',
        'trend_report_border_separator header',
      ),
      columns: [
        {
          Header: selectedCategoryLabel,
          accessor: 'label',
          minWidth: 500,
          className: 'header',
        },
        {
          Header: 'Students Scored',
          accessor: 'studentsScored',
          className: 'header',
        },
        {
          Header: (
            <div className="qns-span">
              {dynamicColspan === 2 ? '# of Qs' : 'Number of Questions'}
            </div>
          ),
          accessor: 'totalQuestions',
          className: 'header',
        },
        getHeaders(),
        minusSignIconHeader,
      ],
    },
    {
      Header: 'ASSIGNMENT PERFORMANCE',
      className: cn(
        'text-gray-700',
        'font-normal',
        'text-base',
        'tracking-wide',
        'header_right',
      ),
      columns: assignmentPerformanceColumns(),
    },
  ];

  const removeColumnByAccessor = (headersToUse, accessorToRemove) =>
    headersToUse.map((section, index) => ({
      ...section,
      columns:
        index === 0
          ? section.columns.filter(
              (column) => column.accessor !== accessorToRemove,
            )
          : section.columns,
    }));
  headers = isStudent
    ? removeColumnByAccessor(headers, 'studentsScored')
    : headers;
  const getHeadersCollapsed = () => {
    const startingIndex = isStudent ? 1 : 0;
    const headersToUse = headers[0];
    headersToUse.columns[3 - startingIndex] = headerAVGPerformanceCollapsed;
    headersToUse.columns[4 - startingIndex] = plusSignIconHeader;
    if (hideAcessments) {
      headersToUse.columns[4 - startingIndex] = noIconHeader;
      headersToUse.columns[0].className = cn('border_radius_left');
    }
    headersToUse.className = cn(
      'hidden',
      'text-gray-700',
      'font-normal',
      'text-base',
      'tracking-wide',
      'trend_report_border_separator',
      'border_radius_right',
    );

    return [headersToUse];
  };

  const dateHeadersCollapsed = (
    <tr>
      <th colSpan={dynamicColspan} />
      <th
        className={cn(
          'trend_report_dates_cell',
          'font-normal',
          'trend_report_border_separator',
        )}
        colSpan={2}
      >
        <div className="text-base">
          {formatDate(firstDateScored)} - {formatDate(lastDateScored)}
        </div>
      </th>
    </tr>
  );

  const dateHeadersExpanded = (
    <tr>
      <th className="header" colSpan={isStudent ? 2 : 3} />
      <th
        className={cn(
          'trend_report_dates_cell',
          'font-normal',
          'trend_report_border_separator',
          'header',
        )}
        colSpan={2}
      >
        <div className="text-base">
          {formatDate(firstDateScored)} - {formatDate(lastDateScored)}
        </div>
      </th>
      {assessments.map(
        ({ firstDateScored: startDate, lastDateScored: endDate }) => (
          <th
            key={Math.random()}
            className="trend_report_dates_cell font-normal header_right"
          >
            <div className="text-base">
              {formatDate(startDate)} - {formatDate(endDate)}
            </div>
          </th>
        ),
      )}
    </tr>
  );

  const { Table, TableBody, TableRow, TableHeader, tableItems } = useTable({
    data: tags,
    headers,
    isManualSorting: false, // set to false to use default table sorting
    initialState: {
      sortBy: [
        {
          id: 'label',
          asc: true,
        },
      ],
    },
    dependeciesForCalculateHeaders: [
      assessments,
      tags,
      selectedCategoryLabel,
      dynamicColspan,
    ],
    aditionalHeaderRows: dateHeadersExpanded,
  });

  const {
    Table: TableCollapsed,
    TableBody: TableBodyCollapsed,
    TableRow: TableRowCollapsed,
    TableHeader: TableHeaderCollapsed,
    tableItems: tableItemsCollapsed,
    sortBy: sortByCollapsed,
  } = useTable({
    data: tags,
    headers: getHeadersCollapsed(),
    isManualSorting: false, // set to false to use default table sorting
    initialState: {
      sortBy: [
        {
          id: 'label',
          asc: true,
        },
      ],
    },
    dependeciesForCalculateHeaders: [
      assessments,
      tags,
      selectedCategoryLabel,
      dynamicColspan,
    ],
    aditionalHeaderRows: hideAcessments ? null : dateHeadersCollapsed,
  });

  useEffect(() => {
    const sortedLabels = (isExpanded ? tableItems : tableItemsCollapsed).map(
      (item) => {
        return item.original.label;
      },
    );
    setSortedLabels(sortedLabels);
  }, [tableItemsCollapsed, tableItems]);

  const onMoveUp = (activeElement) => {
    const { cellIndex } = activeElement;
    activeElement.parentElement.previousElementSibling.children[
      cellIndex
    ].focus();
  };

  const onMoveDown = (activeElement) => {
    const { cellIndex } = activeElement;
    activeElement.parentElement.nextElementSibling.children[cellIndex].focus();
  };

  const onMoveLeft = (activeElement) => {
    activeElement.previousElementSibling.focus();
  };

  const onMoveRight = (activeElement) => {
    activeElement.nextElementSibling.focus();
  };

  const onMoveHome = (activeElement) => {
    activeElement.parentElement.firstElementChild.focus();
  };

  const onMoveEnd = (activeElement) => {
    activeElement.parentElement.lastElementChild.focus();
  };

  const onMoveCtrlHome = (activeElement) => {
    activeElement.parentElement.parentElement.children[1].firstChild.focus();
  };

  const onMoveCtrlEnd = (activeElement) => {
    activeElement.parentElement.parentElement.lastElementChild.lastElementChild.focus();
  };

  // Not sure if we still need this.
  useEffect(() => {
    document.addEventListener('keydown', (e) => {
      let callback;
      const { key, ctrlKey } = e;
      switch (key) {
        case keyNames.arrowUp:
          callback = onMoveUp;
          break;
        case keyNames.arrowDown:
          callback = onMoveDown;
          break;
        case keyNames.arrowLeft:
          callback = onMoveLeft;
          break;
        case keyNames.arrowRight:
          callback = onMoveRight;
          break;
        case keyNames.home:
          callback = ctrlKey ? onMoveCtrlHome : onMoveHome;
          break;
        case keyNames.end:
          callback = ctrlKey ? onMoveCtrlEnd : onMoveEnd;
          break;
        default:
          break;
      }
      if (callback) {
        const { activeElement } = document;
        if (activeElement.tagName === 'TD') {
          // React to keydown event
          e.preventDefault();
          callback(activeElement);
        }
      }
    });
    return () => {
      document.removeEventListener('keydown', () => {});
    };
  }, []);

  useEffect(() => {
    if (isExpanded) {
      const tableElement =
        document.getElementsByClassName('trend_report_table')[0];
      const tableWidth = tableElement.offsetWidth;
      const tableContainerWidth = document.getElementById(
        'trend_report_container',
      ).offsetWidth;
      if (tableWidth > tableContainerWidth) {
        tableElement.style.display = 'block';
      }
    }
  }, [isExpanded]);

  const closePopovers = () => {
    setStudentResultData({});
    setPopoverIsOpen(false);
    const sidebar = document.getElementById('sidebar');
    if (sidebar) sidebar.style.zIndex = null;
  };

  const classNamesforTable = {
    trend_report_table: true,
    assignment_trend_report_table: hideAcessments,
    'mt-10': true,
    table_expanded: isExpanded,
    table_collapsed: !isExpanded,
    trend_report_table_action_open: popoverIsOpen,
    trend_report_table_popover_open: popoverIsOpen,
    trend_report_table_modal_open: tierModalIdxOpen !== null,
  };

  useEffect(() => {
    if (!loading && !isExpanded && tags.length > 0) {
      const firstColumnCellElements = document.querySelectorAll(
        '.trend_report_number_cell__first',
      );
      setMathJaxTypeset(firstColumnCellElements);
    }
  }, [loading, isExpanded, tags, checkedItems, sortByCollapsed]);

  const getVideoUrl = (label) => {
    if (!courseOutline) return undefined;
    const { units } = courseOutline;
    if (!units) return undefined;
    const subUnits = units.reduce((accum, { subunits }) => {
      accum = accum.concat(subunits);
      return accum;
    }, []);
    let subunitSelected;
    if (isRenderingUnit) {
      // open video player for the first subunit of the unit
      subunitSelected = subUnits.find(({ tag }) => `${label}.1` === tag);
    } else if (isRenderingSubunit) {
      // open video player for the subunit
      subunitSelected =
        subUnits.find(({ target }) => target.includes(label)) ||
        subUnits.find(({ tag }) => label === tag);
    }
    if (!subunitSelected) return;
    const { resources } = subunitSelected;
    const videoResources = resources.filter(({ videoId }) => videoId);
    if (!videoResources.length) return; // no videoResources
    const videoResource = videoResources[0];
    const { url } = videoResource;
    return url;
  };

  const renderRow = React.useCallback((row, idx, expanded = false) => {
    const { index, original } = row;
    const totalcellsPerRow = isExpanded ? 9 : 4;
    const {
      label,
      description,
      id,
      studentsScored,
      totalQuestions,
      percentage,
      questionByTagData,
      questionIdsInString,
    } = original;
    // The design for the table requires that the label be bold, but not the description.
    // The description includes the label, so we need to remove the label and apply bold separately
    const nonBoldDescription = description.replace(`${label}:`, '');
    const videoURL = getVideoUrl(label);

    // Filter out the keys that start with assessment_<number> and create a new object with those keys
    const assessmentDict = Object.keys(original)
      .filter((key) => /^assessment_\d+/.test(key))
      .reduce((obj, key) => {
        obj[key] = original[key];
        return obj;
      }, {});

    const TableRowComponent = expanded ? TableRowCollapsed : TableRow;

    const updateZIndexWhenTooltipOpen = (targetElem, removeStyle = false) => {
      if (removeStyle) {
        targetElem.style.zIndex = null;
        return;
      }
      targetElem.style.zIndex = 2;
    };

    const labelDescription = (
      <React.Fragment>
        <span>
          <span className="tag-cell font-bold">{label}:</span>
          <span className="tag-cell mr-2 ml-2">{nonBoldDescription}</span>
        </span>
        {(isRenderingUnit || isRenderingSubunit) && videoURL && !expanded && (
          <span className="ml-auto">
            <Icon
              name="play_circle"
              width="24"
              height="24"
              accessibility={{ ariaHidden: true }}
              onClick={() => openVideo(videoURL)}
            />
          </span>
        )}
      </React.Fragment>
    );

    return (
      <TableRowComponent
        key={idx}
        row={row}
        className={cn({
          active: index === tierModalIdxOpen,
        })}
      >
        <td
          className="trend_report_number_cell__first row_data_left"
          tabIndex={totalcellsPerRow * idx + 1}
          onMouseEnter={(e) => updateZIndexWhenTooltipOpen(e.target)}
          onMouseLeave={(e) => updateZIndexWhenTooltipOpen(e.target, true)}
        >
          <div className="trend_report_topic_cell">
            {expanded && assessments.length > 5 ? (
              <Tooltip
                description={labelDescription}
                containerClassName="tooltip-label-container"
                onTooltipVisible={(tooltipElement) =>
                  setMathJaxTypeset(tooltipElement)
                }
              >
                <span className="tag-cell font-bold mr-2">{label}</span>
              </Tooltip>
            ) : (
              labelDescription
            )}
          </div>
        </td>
        {!isStudent && (
          <td
            className={cn(
              'trend_report_number_cell',
              'trend_report_perf_tier_modal_container',
              'row_data_left',
            )}
            tabIndex={totalcellsPerRow * idx + 2}
          >
            <PerformanceTierPopover
              show={index === tierModalIdxOpen}
              label={description}
              resultsData={studentResultData}
              onClose={closePopovers}
              studentsScored={studentsScored}
              handleNumStudentsClick={handleNumStudentsClick}
              index={index}
              id={id}
              questionIdsInString={questionIdsInString}
            />
          </td>
        )}
        <td
          className={cn(
            'trend_report_number_cell',
            'trend_report_perf_tier_modal_container',
            'row_data_left',
          )}
          tabIndex={totalcellsPerRow * idx + 3}
        >
          {isStudent || totalQuestions === 0 ? (
            <div>{totalQuestions}</div>
          ) : (
            <QuestionsAvgPerformancePopover
              questionByTagData={questionByTagData}
              tagLabel={description}
              onClose={closePopovers}
              index={index}
              totalQuestions={totalQuestions}
              setPopoverIsOpen={setPopoverIsOpen}
            />
          )}
          <div className="preview-player-container"></div>
        </td>
        <td
          colSpan={2}
          className={cn('trend_report_percentage_cell, row_data_left', {
            trend_report_border_separator: isExpanded,
            trend_report_border_right_full: !isExpanded,
          })}
          tabIndex={totalcellsPerRow * idx + 4}
        >
          <PercentageGraph percentage={percentage} />
          <PercentageBox
            percentage={percentage}
            assessmentDict={assessmentDict}
            assessments={assessments}
            labelDescription={`${label}:${nonBoldDescription}`}
            setAssessmentsPopOverData={setAssessmentsPopOverData}
            setIsAssessmentsPopOverOpen={setIsAssessmentsPopOverOpen}
          />
        </td>
        {expanded && (
          <Fragment>
            {assessments.map(({ id }, idxEl) => (
              <td
                key={Math.random()}
                className="trend_report_assessment_cells row_data_right"
                tabIndex={totalcellsPerRow * idx + 4 + idxEl + 1}
              >
                <PercentageGraph
                  percentage={assessmentDict[`assessment_${id}`]}
                  displayBall
                />
              </td>
            ))}
            {!expanded && (
              <td
                style={{ margin: '0', padding: '0', width: '0' }}
                tabIndex={totalcellsPerRow * idx + 4 + assessments.length + 4}
              />
            )}
          </Fragment>
        )}
      </TableRowComponent>
    );
  });

  const DelayText = () => (
    <div className="mt-5 pt-6" style={{ textAlign: 'center' }}>
      *Please note that there may be an up to 15 minute delay for results to be
      included in the Content & Skills Performance report.
    </div>
  );

  if (loading) {
    return <LoadingSpinner />;
  }
  if (!tags.length || !assessments.length) {
    return (
      <div className="pt-6" style={{ textAlign: 'center' }}>
        No results to show. *Please note that there may be an up to 15 minute
        delay for results to be included in the Content & Skills Performance
        report.
      </div>
    );
  }

  if (isExpanded) {
    return (
      <div>
        <div id="trend_report_container" className="table_split">
          <div className="table_left_container">
            <Table className={cn(classNamesforTable, 'table_split_left')}>
              <TableHeader />
              <TableBody>
                {tableItems.map(
                  (item, idx) =>
                    showRow(item.original.percentage, checkedItems) &&
                    renderRow(item, idx, true),
                )}
              </TableBody>
            </Table>
          </div>
          <div className="table_right_container">
            <Table className={cn(classNamesforTable, 'table_split_right')}>
              <TableHeader />
              <TableBody>
                {tableItems.map(
                  (item, idx) =>
                    showRow(item.original.percentage, checkedItems) &&
                    renderRow(item, idx, true),
                )}
              </TableBody>
            </Table>
          </div>
        </div>
        <DelayText />
      </div>
    );
  }

  return (
    <div id="trend_report_container">
      <TableCollapsed className={cn(classNamesforTable)}>
        <TableHeaderCollapsed />
        <TableBodyCollapsed>
          {tableItemsCollapsed.map(
            (item, idx) =>
              showRow(item.original.percentage, checkedItems) &&
              renderRow(item, idx),
          )}
        </TableBodyCollapsed>
      </TableCollapsed>
      <DelayText />
      <AssessmentsModal
        assessmentsPopOverData={assessmentsPopOverData}
        isOpen={isAssessmentsPopOverOpen}
        setIsOpen={setIsAssessmentsPopOverOpen}
      />
    </div>
  );
};

TrendReportTable.defaultProps = {
  setSortedLabels: () => {},
};

const mapStateToProps = (state) => {
  const { userData } = state;
  const { isStudent } = userData;
  return {
    isStudent,
  };
};

export default connect(mapStateToProps)(TrendReportTable);
